<template>
  <div class="health-dashboard">
    <div class="dashboard-left">
      <!-- 个性化建议模块 -->
      <!-- <div v-if="personalizedAdvice" class="advice-card">
        <div class="card-header">
          <div class="title-bar" style="background-color: #52C41A;" />
          <span class="card-title">个性化建议</span>
          <div class="advice-tag" :class="adviceLevel">{{ adviceTag }}</div>
        </div>
        <div class="advice-content">
          <div class="advice-icon">💡</div>
          <div class="advice-text">{{ personalizedAdvice }}</div>
        </div>
        <div class="advice-content">
          <div class="advice-icon">💡</div>
          <div class="advice-text">{{ personalizedAdvice2 }}</div>
        </div>
      </div> -->
      <!-- <div class="health-score-card">
        <div class="card-header">
          <div class="title-bar" style="background-color: #636FCF;" />
          <span class="card-title">当日健康评分</span>
          <div class="score-legend">
            <span class="legend-item red">0-59分</span>
            <span class="legend-item orange">60-84分</span>
            <span class="legend-item green">85-100分</span>
          </div>
        </div>
        <div class="score-content">
          <div class="ring-section">
            <HealthChart
              ref="scoreChart"
              chart-type="ring"
              :view-type="'3'"
              :primary-color="scoreColor"
              :secondary-color="scoreColor"
              :chart-data="[healthScore]"
              :show-charts="true"
              :show-label="false"
              :show-y-axis="false"
              chart-height="220px"
              chart-width="220px"
              :ring-max="100"
            />
          </div>
          <div class="dimension-section">
            <div class="dimension-grid">
              <div class="dimension-item">
                <div class="dimension-icon" style="background-color: #FFF5E6;">🍽️</div>
                <div class="dimension-info">
                  <div class="dimension-name">饮食</div>
                  <div class="dimension-score" :style="{ color: getDimensionColor(dimensionScores.diet) }">{{ dimensionScores.diet }}分</div>
                </div>
              </div>
              <div class="dimension-item">
                <div class="dimension-icon" style="background-color: #E8F4FD;">🏃</div>
                <div class="dimension-info">
                  <div class="dimension-name">运动</div>
                  <div class="dimension-score" :style="{ color: getDimensionColor(dimensionScores.sport) }">{{ dimensionScores.sport }}分</div>
                </div>
              </div>
              <div class="dimension-item">
                <div class="dimension-icon" style="background-color: #F3EFFF;">😴</div>
                <div class="dimension-info">
                  <div class="dimension-name">睡眠</div>
                  <div class="dimension-score" :style="{ color: getDimensionColor(dimensionScores.sleep) }">{{ dimensionScores.sleep }}分</div>
                </div>
              </div>
              <div class="dimension-item">
                <div class="dimension-icon" style="background-color: #FFF0F3;">💆</div>
                <div class="dimension-info">
                  <div class="dimension-name">按摩</div>
                  <div class="dimension-score" :style="{ color: getDimensionColor(dimensionScores.massage) }">{{ dimensionScores.massage }}分</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 用药提醒模块 -->
      <!-- <div class="medicine-card">
        <div class="card-header">
          <div class="title-bar" style="background-color: #1890FF;" />
          <span class="card-title">用药提醒</span>
          <div v-if="todayMedicineStatus" class="medicine-status">
            <span :class="['status-dot', todayMedicineStatus]" />
            <span class="status-text">{{ medicineStatusText }}</span>
          </div>
        </div>
        <div class="medicine-content">
          <div class="medicine-ring-section">
            <div class="ring-label">周期完成率</div>
            <div class="ring-stats">
              <div class="stat-item">
                <span class="stat-value" style="color: #52C41A;">{{ medicineStats.onTime }}</span>
                <span class="stat-label">按时</span>
              </div>
              <div class="stat-item">
                <span class="stat-value" style="color: #FAAD14;">{{ medicineStats.late }}</span>
                <span class="stat-label">晚服</span>
              </div>
              <div class="stat-item">
                <span class="stat-value" style="color: #F56C6C;">{{ medicineStats.missed }}</span>
                <span class="stat-label">漏服</span>
              </div>
            </div>
          </div>

          <div class="medicine-heatmap-section">
            <div class="heatmap-header">
              <span class="heatmap-title">近7天服药情况</span>
              <div class="heatmap-legend">
                <span class="legend-item"><span class="dot green" />按时</span>
                <span class="legend-item"><span class="dot yellow" />晚服</span>
                <span class="legend-item"><span class="dot red" />漏服</span>
                <span class="legend-item"><span class="dot blue" />无需</span>
              </div>
            </div>
            <div class="medicine-heatmap">
              <div
                v-for="(day, index) in medicineHeatmapData"
                :key="index"
                class="heatmap-cell"
                :class="[day.status, { isToday: day.isToday }]"
                @click="handleMedicineClick(day)"
              >
                <div class="cell-date">{{ day.date }}</div>
                <div class="cell-status">{{ day.statusText }}</div>
                <div v-if="day.status === 'missed' && day.reason" class="cell-reason">{{ day.reason }}</div>
              </div>
            </div>
          </div>
        </div>
      </div> -->

      <!-- 饮食、运动、睡眠、按摩记录 -->
      <HealthChart
        ref="dietChart"
        key="diet-chart"
        title="饮食记录"
        chart-type="bar"
        :view-type="dietType"
        :day-data="dietDayData"
        :primary-color="dietColors.primary"
        :secondary-color="dietColors.secondary"
        :bar-color="dietColors.bar"
        :icon-bg-color="dietColors.iconBg"
        :chart-data="dietData"
        :x-axis-data="dietXAxisData"
        :show-charts="foodShow"
        :y-axis-max="4"
        chart-height="200px"
        @tab-change="(tab) => handleTabChange('diet', tab)"
      />
      <HealthChart
        ref="sportChart"
        key="sport-chart"
        title="运动记录"
        chart-type="bar"
        :view-type="sportType"
        :day-data="sportDayData"
        :primary-color="sportColors.primary"
        :secondary-color="sportColors.secondary"
        :bar-color="sportColors.bar"
        :icon-bg-color="sportColors.iconBg"
        :chart-data="sportData"
        :x-axis-data="sportXAxisData"
        :stats-value="sportStats.totalCount"
        :stats-label="currentSportStatsLabel"
        icon-class="el-icon-s-promotion"
        :show-stats="true"
        :y-axis-max="4"
        :show-label="false"
        :show-charts="sportShow"
        chart-height="220px"
        @tab-change="(tab) => handleTabChange('sport', tab)"
      ><template #icon><i class="sport-icon">🏃</i></template></HealthChart>
      <HealthChart
        ref="sleepChart"
        key="sleep-chart"
        title="睡眠记录"
        chart-type="line"
        :view-type="sleepType"
        :day-data="sleepDayData"
        :primary-color="sleepColors.primary"
        :secondary-color="sleepColors.secondary"
        :bar-color="sleepColors.bar"
        :icon-bg-color="sleepColors.iconBg"
        :chart-data="sleepData"
        :x-axis-data="sleepXAxisData"
        :y-axis-max="12"
        :area-opacity="0.25"
        :show-charts="sleepShow"
        chart-height="200px"
        @tab-change="(tab) => handleTabChange('sleep', tab)"
      />
      <HealthChart
        ref="massageChart"
        key="massage-chart"
        title="按摩记录"
        chart-type="line"
        :view-type="massageType"
        :day-data="massageDayData"
        :primary-color="massageColors.primary"
        :secondary-color="massageColors.secondary"
        :bar-color="massageColors.bar"
        :icon-bg-color="massageColors.iconBg"
        :chart-data="massageData"
        :x-axis-data="massageXAxisData"
        :stats-value="massageStats.totalCount"
        :stats-label="currentMassageStatsLabel"
        :show-stats="true"
        :y-axis-max="8"
        :show-label="false"
        :area-opacity="0.3"
        :show-charts="massageShow"
        chart-height="200px"
        @tab-change="(tab) => handleTabChange('massage', tab)"
      ><template #icon><i class="massage-icon">💆</i></template></HealthChart>
    </div>

    <!-- 右侧数字人区域 -->
    <div class="digital-human-section">
      <div class="points-badge" title="点击查看积分明细" @click="openPointsDialog">
        <span class="points-value">{{ countIntegral }}</span>
        <span class="points-label">积分</span>
      </div>
      <div class="digital-human-container">
        <img v-if="sexsign !== 1" src="@/assets/icon/numwuman.png" alt="数字人" class="digital-human-img">
        <img v-if="sexsign === 1" src="@/assets/icon/numman.png" alt="数字人" class="digital-human-img">
      </div>
      <div class="chat-bubble" @click="viewConstitutionReport">
        <div class="bubble-arrow" />
        <p class="bubble-text">我是{{ tizhi.name }}，请点击查看我的体质报告</p>
      </div>
    </div>

    <!-- 漏服原因选择弹窗 -->
    <el-dialog title="标记漏服原因" :visible.sync="missedReasonDialogVisible" width="400px" :close-on-click-modal="false">
      <div class="missed-reason-content">
        <p class="reason-tip">请选择今日未服用药物的原因：</p>
        <el-radio-group v-model="selectedMissedReason" class="reason-group">
          <el-radio label="forgot">忘记服用</el-radio>
          <el-radio label="side_effect">出现副作用</el-radio>
          <el-radio label="not_available">药物不在身边</el-radio>
          <el-radio label="feel_better">感觉好转自行停药</el-radio>
          <el-radio label="other">其他原因</el-radio>
        </el-radio-group>
        <el-input v-if="selectedMissedReason === 'other'" v-model="otherReasonText" placeholder="请输入其他原因" style="margin-top: 10px;" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="missedReasonDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmMissedReason">确认标记</el-button>
      </div>
    </el-dialog>

    <!-- 体质报告弹窗 -->
    <el-dialog title="体质报告" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="true" custom-class="constitution-dialog" append-to-body>
      <div class="constitution-content" v-html="constitutionContent" />
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 积分明细弹窗 -->
    <el-dialog title="积分明细" :visible.sync="pointsDialogVisible" width="600px" :close-on-click-modal="true" custom-class="points-dialog" append-to-body>
      <div class="points-table-container">
        <el-table v-loading="!countIntegralList.length" :data="countIntegralList" stripe style="width: 100%" height="250px">
          <el-table-column prop="pointsLogDesc" label="事件" min-width="200" show-overflow-tooltip />
          <el-table-column prop="integralChange" label="积分变动" width="120" align="center">
            <template slot-scope="scope">
              <span :class="scope.row.integralChange >= 0 ? 'points-plus' : 'points-minus'">{{ scope.row.integralChange }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-container">
        <el-pagination background layout="prev, pager, next, total" :current-page.sync="currentPage" :page-size="pageSize" :total="totalCount" @current-change="handlePointsPageChange" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pointsDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HealthChart from './HealthChart.vue'
import { postData } from "@/api/user/authApi"
import { getfindByCode } from '@/api/ik/data/health'

export default {
  name: 'HealthDashboard',
  components: { HealthChart },
  data() {
    return {
      userCode: '',
      token: '',
      sexsign: 1,
      storeCode: '',
      countIntegral: 0,
      countIntegralList: [],
      pointsDialogVisible: false,
      currentPage: 1,
      pageSize: 5,
      totalCount: 0,
      dialogVisible: false,
      constitutionContent: '',
      foodShow: true,
      massageShow: true,
      sportShow: true,
      sleepShow: true,
      dietType: "3",
      sportType: "3",
      sleepType: "3",
      massageType: "3",
      tizhi: {},

      // 假数据：健康评分
      healthScore: 78,
      dimensionScores: { diet: 22, sport: 18, sleep: 20, massage: 18 },

      // ========== 新增：个性化建议数据 ==========
      yesterdaySleepDuration: 5.5, // 假数据：昨日睡眠时长（小时）

      // ========== 新增：用药提醒数据 ==========
      medicineCompletionRate: 85, // 周期完成率
      medicineStats: { onTime: 18, late: 2, missed: 1 }, // 统计
      todayMedicineStatus: '', // 今日状态：'', 'taken', 'missed'
      missedReasonDialogVisible: false,
      selectedMissedReason: '',
      otherReasonText: '',
      // 近7天服药热力图数据（假数据）
      medicineHeatmapData: [
        { date: '12.11', status: 'ontime', statusText: '按时', day: '周一' },
        { date: '12.12', status: 'ontime', statusText: '按时', day: '周二' },
        { date: '12.13', status: 'late', statusText: '晚服', day: '周三', note: '晚2小时' },
        { date: '12.14', status: 'ontime', statusText: '按时', day: '周四' },
        { date: '12.15', status: 'missed', statusText: '漏服', day: '周五', reason: '忘记' },
        { date: '12.16', status: 'ontime', statusText: '按时', day: '周六' },
        { date: '12.17', status: 'none', statusText: '今日', day: '周日', isToday: true }
      ],

      dietColors: { primary: '#FF9F43', secondary: '#FFD89B', bar: '#333', iconBg: '#FFF5E6' },
      sportColors: { primary: '#4A90E2', secondary: '#A8D0F0', bar: '#333', iconBg: '#E8F4FD' },
      sleepColors: { primary: '#9B7ED9', secondary: '#D4C5F0', bar: '#333', iconBg: '#F3EFFF' },
      massageColors: { primary: '#FF7B9D', secondary: '#FFC5D5', bar: '#333', iconBg: '#FFF0F3' },
      dietXAxisData: [],
      sportXAxisData: [],
      sleepXAxisData: [],
      massageXAxisData: [],
      dietData: [],
      foodRawData: [],
      fastFoodNum: 0,
      dietDayData: null,
      sportData: [],
      sportRawData: [],
      sportStats: { totalCount: 0, standard: 0, notStandard: 0 },
      sportDayData: null,
      sleepData: [],
      sleepRawData: [],
      sleepStats: { avgDuration: 0 },
      sleepDayData: null,
      massageData: [],
      massageRawData: [],
      massageStats: { totalCount: 0 },
      massageDayData: null
    }
  },
  computed: {
    currentSportStatsLabel() {
      const map = { '1': '今日运动（次）', '2': '本周运动（次）', '3': '本月运动（次）' }
      return map[this.sportType] || '本月运动（次）'
    },
    currentMassageStatsLabel() {
      const map = { '1': '今日按摩（次数）', '2': '本周按摩（次数）', '3': '本月按摩（次数）' }
      return map[this.massageType] || '本月按摩（次数）'
    },
    scoreColor() {
      if (this.healthScore < 60) return '#F56C6C'
      else if (this.healthScore < 85) return '#FF9F43'
      else return '#67C23A'
    },
    // ========== 新增：个性化建议计算 ==========
    personalizedAdvice() {
      const duration = this.yesterdaySleepDuration
      if (duration < 6) {
        return '昨日睡眠时间略显不足。建议今日优先进行放松按摩，帮助身体恢复。今晚提前15分钟放下手机，按时睡眠，目标是睡足7小时。'
      } else if (duration >= 6 && duration < 7) {
        return '昨日睡眠时间接近达标。建议今晚提前15分钟放下手机，按时睡眠，目标是睡足7小时。'
      }
      return ''
    },
    personalizedAdvice2() {
      const duration = this.yesterdaySleepDuration
      if (duration >= 6 && duration < 7) {
        return '昨日睡眠时间略显不足。建议今日优先进行放松按摩，帮助身体恢复。今晚提前15分钟放下手机，按时睡眠，目标是睡足7小时。'
      } else if (duration < 6) {
        return '昨日睡眠时间接近达标。建议今晚提前15分钟放下手机，按时睡眠，目标是睡足7小时。'
      }
      return ''
    },
    adviceLevel() {
      if (this.yesterdaySleepDuration < 6) return 'warning'
      if (this.yesterdaySleepDuration < 7) return 'info'
      return 'success'
    },
    adviceTag() {
      if (this.yesterdaySleepDuration < 6) return '睡眠不足'
      if (this.yesterdaySleepDuration < 7) return '睡眠一般'
      return '睡眠良好'
    },
    // ========== 新增：用药提醒计算 ==========
    medicineRingColor() {
      if (this.medicineCompletionRate >= 90) return '#52C41A'
      if (this.medicineCompletionRate >= 70) return '#FAAD14'
      return '#F56C6C'
    },
    medicineStatusText() {
      const statusMap = { 'taken': '已服用', 'missed': '未服用', '': '待记录' }
      return statusMap[this.todayMedicineStatus] || '待记录'
    },
    showMedicineActions() {
      return !this.todayMedicineStatus && this.medicineHeatmapData.some(d => d.isToday)
    }
  },
  created() {
    this.initUserCodeFromRoute()
    this.initTokenFromRoute()
    this.initSexsignFromRoute()
    this.initStoreCodeFromRoute()
    this.getPhydiagrecord()
    this.getintegral()
    this.checkTodayMedicineStatus()
    this.loadAllData()
  },
  methods: {
    getDimensionColor(score) {
      if (score < 15) return '#F56C6C'
      if (score < 21) return '#FF9F43'
      return '#67C23A'
    },
    calculateHealthScore() {
      console.log('【假数据模式】当前健康评分:', { total: this.healthScore, dimensions: this.dimensionScores, color: this.scoreColor })
    },

    // ========== 新增：用药提醒方法 ==========
    checkTodayMedicineStatus() {
      const today = this.medicineHeatmapData.find(d => d.isToday)
      if (today && today.status !== 'none') {
        this.todayMedicineStatus = today.status === 'ontime' ? 'taken' : today.status
      }
    },
    handleMedicineClick(day) {
      if (!day.isToday) return
      if (day.status === 'missed') {
        this.$message.info(`漏服原因：${day.reason || '未记录'}`)
      }
    },
    confirmMedicine(status) {
      if (status === 'taken') {
        this.todayMedicineStatus = 'taken'
        const todayIndex = this.medicineHeatmapData.findIndex(d => d.isToday)
        if (todayIndex !== -1) {
          this.$set(this.medicineHeatmapData, todayIndex, {
            ...this.medicineHeatmapData[todayIndex],
            status: 'ontime',
            statusText: '按时'
          })
        }
        this.$message.success('已确认今日用药，继续保持！')
        this.medicineStats.onTime++
      }
    },
    showMissedReasonDialog() {
      this.missedReasonDialogVisible = true
    },
    confirmMissedReason() {
      if (!this.selectedMissedReason) {
        this.$message.warning('请选择漏服原因')
        return
      }
      const reasonMap = {
        'forgot': '忘记服用',
        'side_effect': '出现副作用',
        'not_available': '药物不在身边',
        'feel_better': '感觉好转自行停药',
        'other': this.otherReasonText || '其他原因'
      }
      this.todayMedicineStatus = 'missed'
      const todayIndex = this.medicineHeatmapData.findIndex(d => d.isToday)
      if (todayIndex !== -1) {
        this.$set(this.medicineHeatmapData, todayIndex, {
          ...this.medicineHeatmapData[todayIndex],
          status: 'missed',
          statusText: '漏服',
          reason: reasonMap[this.selectedMissedReason]
        })
      }
      this.medicineStats.missed++
      this.$message.info('已记录漏服，请尽快补服或咨询医生')
      this.missedReasonDialogVisible = false
      this.selectedMissedReason = ''
      this.otherReasonText = ''
    },

    initUserCodeFromRoute() {
      const code = this.$route.query.userCode || this.$route.params.userCode || ''
      if (code) {
        this.userCode = code
        this.loadAllData()
      }
    },
    initStoreCodeFromRoute() {
      const storeCode = this.$route.query.storeCode || this.$route.params.storeCode || ''
      if (storeCode) this.storeCode = storeCode
    },
    getPhydiagrecord() {
      if (!this.userCode) return
      postData('health/diagnosis/physique/phydiagrecord/find/findphyrecord', { "userCode": this.userCode, "storeCode": this.storeCode }).then(response => {
        this.tizhi = response.data
      })
    },
    initTokenFromRoute() {
      const token = this.$route.query.token || this.$route.params.token || ''
      if (token) {
        this.token = token
        this.handleTokenUpdate(token)
      }
    },
    initSexsignFromRoute() {
      const sexsign = this.$route.query.sexsign || this.$route.params.sexsign
      if (sexsign !== undefined && sexsign !== '') {
        this.sexsign = parseInt(sexsign) || 1
      }
    },
    handleTokenUpdate(token) {
      localStorage.setItem('health_token', token)
    },
    loadAllData() {
      if (!this.userCode) return
      this.getfoodrecord(this.dietType)
      this.getsportrecord(this.sportType)
      this.gethealthStatssleeprecord(this.sleepType)
      this.getmassagerecord(this.massageType)
    },
    clearAllData() {
      this.dietData = []
      this.dietXAxisData = []
      this.dietDayData = null
      this.sportData = []
      this.sportXAxisData = []
      this.sportDayData = null
      this.sportStats = { totalCount: 0, standard: 0, notStandard: 0 }
      this.sleepData = []
      this.sleepXAxisData = []
      this.sleepDayData = null
      this.sleepStats = { avgDuration: 0 }
      this.massageData = []
      this.massageXAxisData = []
      this.massageDayData = null
      this.massageStats = { totalCount: 0 }
    },
    handleTabChange(chartType, tab) {
      const typeMap = { '日': '1', '周': '2', '月': '3' }
      const type = typeMap[tab] || "3"
      const showChart = type !== '1'
      switch (chartType) {
        case 'diet': this.dietType = type; this.foodShow = showChart; this.getfoodrecord(type); break
        case 'sport': this.sportType = type; this.sportShow = showChart; this.getsportrecord(type); break
        case 'sleep': this.sleepType = type; this.sleepShow = showChart; this.gethealthStatssleeprecord(type); break
        case 'massage': this.massageType = type; this.massageShow = showChart; this.getmassagerecord(type); break
      }
    },
    viewConstitutionReport() {
      this.getcontentlist()
    },
    getintegral(page = 1) {
      postData('base/user/user/user/find/getscorebytoken', { pageNo: page, pageSize: this.pageSize, token: this.token }).then(res => {
        this.countIntegral = res.data.data.countIntegral
        this.countIntegralList = res.data.data.pageInfoS.list
        this.totalCount = res.data.data.pageInfoS.totalCount || 0
        this.currentPage = page
      })
    },
    openPointsDialog() {
      this.pointsDialogVisible = true
      this.currentPage = 1
      this.getintegral(1)
    },
    handlePointsPageChange(page) {
      this.getintegral(page)
    },
    getcontentlist() {
      postData('health/diagnosis/physique/phydiagrecord/find/getdefaultcontent', { phyTypeCode: this.tizhi.code, storeCode: this.storeCode, sexSign: String(this.sexsign) }).then(res => {
        getfindByCode('', { code: res.data.contentInfoCode }).then(res => {
          this.constitutionContent = res.data.head.htmlContent || ''
          this.dialogVisible = true
        }).catch(() => { this.$message.error('获取体质报告失败') })
      }).catch(() => { this.$message.error('获取体质信息失败') })
    },
    formatDate(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    getMonthDates(year, month) {
      const dates = []
      const lastDay = new Date(year, month + 1, 0).getDate()
      for (let d = 1; d <= lastDay; d++) {
        const date = new Date(year, month, d)
        dates.push(this.formatDate(date))
      }
      return dates
    },
    getWeekDates(baseDate) {
      const dates = []
      const day = baseDate.getDay()
      const monday = new Date(baseDate)
      monday.setDate(baseDate.getDate() - (day === 0 ? 6 : day - 1))
      for (let i = 0; i < 7; i++) {
        const date = new Date(monday)
        date.setDate(monday.getDate() + i)
        dates.push(this.formatDate(date))
      }
      return dates
    },
    generateDateList(type) {
      const baseDate = new Date()
      let fullDates = []
      if (type === "2") fullDates = this.getWeekDates(baseDate)
      else if (type === "3") fullDates = this.getMonthDates(baseDate.getFullYear(), baseDate.getMonth())
      else fullDates = [this.formatDate(baseDate)]
      return fullDates
    },
    getTodayString() {
      return this.formatDate(new Date())
    },
    formatToMD(dateStr) {
      const parts = dateStr.split('-')
      return `${parts[1]}.${parts[2]}`
    },
    getfoodrecord(type) {
      if (!this.userCode) return
      postData('health/health/record/foodrecord/find/statsfoodrecord', { "userCode": this.userCode, "type": type }).then(res => {
        const records = res.data.record || res.data || []
        this.foodRawData = res.data
        let fastCount = 0
        if (res.data.record) {
          res.data.record.forEach(item => {
            if (item.fastingFoodContent) fastCount++
          })
        }
        this.fastFoodNum = fastCount

        if (type === '1') {
          const today = this.getTodayString()
          const todayRecords = records.filter(item => {
            const timestamp = Number(item.recordDate)
            const date = new Date(timestamp > 1e10 ? timestamp : timestamp * 1000)
            return this.formatDate(date) === today
          })

          this.dietDayData = {
            count: todayRecords.length,
            summary: [
              { label: '今日餐次', value: todayRecords.length },
              { label: '忌口餐次', value: todayRecords.filter(r => r.fastingFoodContent).length }
            ],
            records: todayRecords.map(item => ({
              time: item.recordTime || new Date(Number(item.recordDate)).toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' }),
              title: item.foodContent || '饮食记录',
              subtitle: item.foodTypeName || '',
              tags: item.fastingFoodContent ? [{ label: '忌口', color: '#FF6B6B' }] : [],
              value: item.calories || ''
            }))
          }
          this.dietData = []
          this.dietXAxisData = []
          return
        }

        const fullDates = this.generateDateList(type)
        const countByDate = new Map()
        records.forEach(item => {
          const timestamp = Number(item.recordDate)
          const date = new Date(timestamp > 1e10 ? timestamp : timestamp * 1000)
          const dateStr = this.formatDate(date)
          countByDate.set(dateStr, (countByDate.get(dateStr) || 0) + 1)
        })

        this.dietData = fullDates.map(dateStr => countByDate.get(dateStr) || 0)
        this.dietXAxisData = fullDates.map(dateStr => this.formatToMD(dateStr))
      })
    },
    getsportrecord(type) {
      if (!this.userCode) return
      postData('health/health/record/sportrecord/find/statsmotionrecord', { "userCode": this.userCode, "type": type }).then(res => {
        this.sportRawData = res.data.record
        const records = Array.isArray(res.data.record) ? res.data.record : []

        if (type === '1') {
          const today = this.getTodayString()
          const todayRecords = records.filter(item => {
            const timestamp = Number(item.recordDate)
            const date = new Date(timestamp > 1e10 ? timestamp : timestamp * 1000)
            return this.formatDate(date) === today
          })

          this.sportDayData = {
            count: todayRecords.length,
            summary: [{ label: '今日运动', value: todayRecords.length + '次' }],
            records: todayRecords.map((item, index) => ({
              time: item.recordTime || new Date(Number(item.recordDate)).toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' }),
              title: item.motionName || '运动记录',
              subtitle: item.motionTypeName || '',
              tags: item.isStandard ? [{ label: '达标', color: '#52C41A' }] : [{ label: '未达标', color: '#FAAD14' }],
              value: index + 1
            }))
          }

          this.sportStats = {
            totalCount: todayRecords.length,
            standard: todayRecords.filter(r => r.isStandard).length,
            notStandard: todayRecords.filter(r => !r.isStandard).length
          }
          this.sportData = []
          this.sportXAxisData = []
          return
        }

        let standard = 0; let notStandard = 0
        records.forEach(item => {
          if (item.isStandard) standard++
          else notStandard++
        })

        this.sportStats = { totalCount: records.length, standard, notStandard }
        const fullDates = this.generateDateList(type)
        const dataMap = new Map()

        records.forEach(item => {
          const timestamp = Number(item.recordDate)
          const date = new Date(timestamp > 1e10 ? timestamp : timestamp * 1000)
          const dateStr = this.formatDate(date)
          dataMap.set(dateStr, (dataMap.get(dateStr) || 0) + 1)
        })

        this.sportData = fullDates.map(dateStr => dataMap.get(dateStr) || 0)
        this.sportXAxisData = fullDates.map(dateStr => this.formatToMD(dateStr))
      })
    },
    gethealthStatssleeprecord(type) {
      if (!this.userCode) return
      postData('health/health/record/sleeprecord/find/statssleeprecord', { "userCode": this.userCode, "type": type }).then(res => {
        this.sleepRawData = res.data
        const records = Array.isArray(res.data) ? res.data : []

        if (type === '1') {
          const today = this.getTodayString()
          const todayRecord = records.find(item => item.recordDate === today)

          if (todayRecord) {
            const duration = Number(todayRecord.sleepDuration || 0)
            const hours = Math.floor(duration)
            const minutes = Math.round((duration - hours) * 60)

            this.sleepDayData = {
              count: 1,
              summary: [
                { label: '睡眠时长', value: `${hours}小时${minutes > 0 ? minutes + '分' : ''}` },
                { label: '起床时间', value: todayRecord.recordEndTime || '-' }
              ],
              records: [{
                time: todayRecord.recordEndTime || '-',
                title: '睡眠记录',
                subtitle: `入睡时间: ${todayRecord.recordStartTime || '-'}`,
                tags: duration >= 7 ? [{ label: '充足', color: '#52C41A' }]
                  : duration >= 5 ? [{ label: '正常', color: '#4A90E2' }]
                    : [{ label: '不足', color: '#FAAD14' }],
                value: duration,
                unit: '小时'
              }]
            }
          } else {
            this.sleepDayData = { count: 0, summary: [{ label: '睡眠时长', value: '未记录' }], records: [] }
          }
          this.sleepData = []
          this.sleepXAxisData = []
          return
        }

        const baseDate = new Date()
        let fullDates = []
        if (type === "2") fullDates = this.getWeekDates(baseDate)
        else if (type === "3") fullDates = this.getMonthDates(baseDate.getFullYear(), baseDate.getMonth())

        const dataMap = new Map()
        let totalSleep = 0; let count = 0

        records.forEach(item => {
          dataMap.set(item.recordDate, { value: Number(item.sleepDuration || 0), time: item.recordEndTime })
          totalSleep += Number(item.sleepDuration || 0)
          count++
        })

        this.sleepData = fullDates.map(date => { const record = dataMap.get(date); return record ? record.value : 0 })
        this.sleepStats.avgDuration = count > 0 ? (totalSleep / count).toFixed(1) : 0
        this.sleepXAxisData = fullDates.map(dateStr => this.formatToMD(dateStr))
      })
    },
    getmassagerecord(type) {
      if (!this.userCode) return
      postData('health/health/record/massagerecord/find/statsmassagerecord', { "userCode": this.userCode, "type": type }).then(res => {
        this.massageRawData = res.data.record
        const records = Array.isArray(res.data.record) ? res.data.record : []

        if (type === '1') {
          const today = this.getTodayString()
          const todayRecords = records.filter(item => {
            const timestamp = Number(item.recordDate)
            const date = new Date(timestamp > 1e10 ? timestamp : timestamp * 1000)
            return this.formatDate(date) === today
          })

          this.massageDayData = {
            count: todayRecords.length,
            summary: [{ label: '今日按摩', value: todayRecords.length + '次' }],
            records: todayRecords.map((item, index) => ({
              time: item.recordTime || new Date(Number(item.recordDate)).toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' }),
              title: item.massageTypeName || '按摩记录',
              subtitle: item.remark || '',
              tags: item.isProfessional ? [{ label: '专业按摩', color: '#9B7ED9' }] : [],
              value: index + 1
            }))
          }

          this.massageStats.totalCount = todayRecords.length
          this.massageData = []
          this.massageXAxisData = []
          return
        }

        this.massageStats.totalCount = records.length
        const fullDates = this.generateDateList(type)
        const dataMap = new Map()

        records.forEach(item => {
          const timestamp = Number(item.recordDate)
          const date = new Date(timestamp > 1e10 ? timestamp : timestamp * 1000)
          const dateStr = this.formatDate(date)
          dataMap.set(dateStr, (dataMap.get(dateStr) || 0) + 1)
        })

        this.massageData = fullDates.map(dateStr => dataMap.get(dateStr) || 0)
        this.massageXAxisData = fullDates.map(dateStr => this.formatToMD(dateStr))
      }).catch(() => {
        if (type === '1') {
          this.massageDayData = { count: 2, summary: [{ label: '今日按摩', value: '2次' }], records: [{ time: '14:00', title: '肩颈按摩', subtitle: '放松舒缓', tags: [{ label: '专业', color: '#9B7ED9' }], value: 1 }, { time: '20:30', title: '足底按摩', subtitle: '促进血液循环', tags: [], value: 2 }] }
        } else {
          this.massageData = [3, 4, 2, 4, 3, 4, 3]
          this.massageStats.totalCount = 23
          this.massageXAxisData = ['12.15', '12.16', '12.17', '12.18', '12.19', '12.20', '12.21']
        }
      })
    }
  }
}
</script>

<style scoped>
.health-dashboard {
  display: flex;
  gap: 12px;
  padding: 12px;
  background: #FFFFFF;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;
}

.dashboard-left {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* ========== 个性化建议卡片 ========== */
.advice-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  border-left: 4px solid #52C41A;
}

.advice-card .card-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  gap: 8px;
}

.advice-card .title-bar {
  width: 4px;
  height: 16px;
  border-radius: 2px;
  margin-right: 10px;
}

.advice-card .card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  flex: 1;
}

.advice-tag {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.advice-tag.warning {
  background: #FFF2F0;
  color: #F56C6C;
  border: 1px solid #FFCCC7;
}

.advice-tag.info {
  background: #FFF7E6;
  color: #FA8C16;
  border: 1px solid #FFD591;
}

.advice-tag.success {
  background: #F6FFED;
  color: #52C41A;
  border: 1px solid #B7EB8F;
}

.advice-content {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: #F6FFED;
  border-radius: 8px;
}

.advice-icon {
  font-size: 24px;
  flex-shrink: 0;
}

.advice-text {
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}

/* ========== 用药提醒卡片 ========== */
.medicine-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.medicine-card .card-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  gap: 8px;
}

.medicine-card .title-bar {
  width: 4px;
  height: 16px;
  border-radius: 2px;
  margin-right: 10px;
}

.medicine-card .card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  flex: 1;
}

.medicine-status {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
}

.status-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.status-dot.taken { background: #52C41A; }
.status-dot.missed { background: #F56C6C; }
.status-dot.ontime { background: #52C41A; }
.status-dot.late { background: #FAAD14; }

.medicine-content {
  display: flex;
  gap: 20px;
}

.medicine-ring-section {
  width: 220px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  background: #F0F5FF;
  border-radius: 12px;
}

.ring-label {
  font-size: 13px;
  color: #1890FF;
  font-weight: 600;
  margin-bottom: 8px;
}

.ring-stats {
  display: flex;
  justify-content: space-around;
  width: 100%;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #D6E4FF;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.stat-value {
  font-size: 18px;
  font-weight: 700;
}

.stat-label {
  font-size: 11px;
  color: #666;
}

.medicine-heatmap-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.heatmap-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.heatmap-title {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.heatmap-legend {
  display: flex;
  gap: 12px;
  font-size: 12px;
  color: #666;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.legend-item .dot {
  width: 8px;
  height: 8px;
  border-radius: 2px;
}

.legend-item .dot.green { background: #52C41A; }
.legend-item .dot.yellow { background: #FAAD14; }
.legend-item .dot.red { background: #F56C6C; }
.legend-item .dot.blue { background: #1890FF; }

.medicine-heatmap {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
}

.heatmap-cell {
  aspect-ratio: 1;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  border: 2px solid transparent;
}

.heatmap-cell:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

.heatmap-cell.ontime {
  background: #F6FFED;
  border-color: #52C41A;
}

.heatmap-cell.late {
  background: #FFF7E6;
  border-color: #FAAD14;
}

.heatmap-cell.missed {
  background: #FFF2F0;
  border-color: #F56C6C;
}

.heatmap-cell.none {
  background: #F5F5F5;
  border-color: #D9D9D9;
  border-style: dashed;
}

.heatmap-cell.isToday {
  position: relative;
}

.heatmap-cell.isToday::after {
  content: '今';
  position: absolute;
  top: -4px;
  right: -4px;
  width: 16px;
  height: 16px;
  background: #1890FF;
  color: white;
  font-size: 10px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cell-date {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

.cell-status {
  font-size: 11px;
  color: #666;
  margin-top: 2px;
}

.cell-reason {
  font-size: 10px;
  color: #F56C6C;
  margin-top: 2px;
  padding: 0 4px;
  background: rgba(245, 108, 108, 0.1);
  border-radius: 4px;
}

.today-medicine-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: #FFF7E6;
  border-radius: 8px;
  border: 1px solid #FFD591;
}

.action-text {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.action-buttons {
  display: flex;
  gap: 8px;
}

/* ========== 健康评分卡片 ========== */
.health-score-card {
  background: #fff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.health-score-card .card-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 8px;
}

.health-score-card .title-bar {
  width: 4px;
  height: 16px;
  border-radius: 2px;
  margin-right: 10px;
}

.health-score-card .card-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  flex: 1;
}

.score-legend {
  display: flex;
  gap: 12px;
  font-size: 12px;
}

.score-legend .legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.score-legend .legend-item::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.score-legend .legend-item.red { color: #F56C6C; }
.score-legend .legend-item.red::before { background-color: #F56C6C; }
.score-legend .legend-item.orange { color: #FF9F43; }
.score-legend .legend-item.orange::before { background-color: #FF9F43; }
.score-legend .legend-item.green { color: #67C23A; }
.score-legend .legend-item.green::before { background-color: #67C23A; }

.score-content {
  display: flex;
  align-items: center;
  gap: 24px;
}

.ring-section {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  /* background: linear-gradient(135deg, #f8faff 0%, #f0f4ff 100%); */
  border-radius: 50%;
  /* border: 2px solid #e8ecff; */
}

.dimension-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dimension-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.dimension-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px;
  background: #fafbfc;
  border-radius: 10px;
  transition: all 0.3s;
}

.dimension-item:hover {
  background: #f5f7fa;
  transform: translateX(4px);
}

.dimension-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}

.dimension-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.dimension-name {
  font-size: 13px;
  color: #666;
}

.dimension-score {
  font-size: 18px;
  font-weight: 700;
}

.total-score-bar {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  gap: 4px;
  padding: 12px 16px;
  background: #f8faff;
  border-radius: 8px;
  border-left: 4px solid #636FCF;
}

.total-label {
  font-size: 14px;
  color: #666;
  margin-right: 8px;
}

.total-value {
  font-size: 32px;
  font-weight: 700;
  line-height: 1;
}

.total-unit {
  font-size: 14px;
  color: #999;
}

/* ========== 漏服原因弹窗 ========== */
.missed-reason-content {
  padding: 10px 0;
}

.reason-tip {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
}

.reason-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.reason-group >>> .el-radio {
  margin-right: 0;
}

/* ========== 右侧数字人区域 ========== */
.digital-human-section {
  width: 140px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 20px;
  background: #fff;
  position: relative;
  overflow: visible;
}

.points-badge {
  position: absolute;
  left: -10px;
  top: 12%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #636FCF;
  box-shadow: inset 0 2px 6px rgba(135, 206, 235, 0.6), inset 0 -1px 4px rgba(255, 255, 255, 0.8), 0 2px 6px rgba(0, 0, 0, 0.08);
  z-index: 10;
  backdrop-filter: blur(4px);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.points-badge:hover {
  transform: translateY(-50%) scale(1.05);
  box-shadow: inset 0 2px 6px rgba(135, 206, 235, 0.8), inset 0 -1px 4px rgba(255, 255, 255, 0.9), 0 4px 12px rgba(99, 111, 207, 0.3);
}

.points-value {
  font-weight: bold;
  font-size: 15px;
  line-height: 1;
  margin-bottom: 2px;
}

.points-label {
  font-size: 12px;
  opacity: 0.9;
}

.digital-human-container {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  z-index: 5;
  margin-top: 60px;
}

.digital-human-img {
  width: 100px;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.1));
}

.chat-bubble {
  background: white;
  border-radius: 12px;
  padding: 10px 12px;
  max-width: 120px;
  box-shadow: inset 0 2px 6px rgba(116, 178, 253, 0.8), 0 3px 12px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  animation: float 3s ease-in-out infinite;
  position: relative;
  z-index: 5;
  margin-top: 16px;
}

.chat-bubble:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
}

.bubble-text {
  margin: 0;
  font-size: 12px;
  color: #3177F1;
  line-height: 1.4;
  font-weight: 500;
  text-align: center;
}

.bubble-arrow {
  position: absolute;
  top: -6px;
  right: 24px;
  width: 12px;
  height: 6px;
  background: white;
  box-shadow: inset 0 2px 6px rgba(116, 178, 253, 0.6);
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
}

@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-6px); }
}

.sport-icon, .massage-icon {
  font-size: 24px;
  font-style: normal;
}

/* ========== 响应式适配 ========== */
@media screen and (max-width: 900px) and (min-width: 700px) {
  .medicine-content {
    flex-direction: column;
  }
  .medicine-ring-section {
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
  }
  .ring-stats {
    border-top: none;
    border-left: 1px solid #D6E4FF;
    padding-top: 0;
    padding-left: 20px;
    margin-top: 0;
  }
  .score-content {
    flex-direction: column;
    align-items: center;
  }
  .dimension-section {
    width: 100%;
  }
  .digital-human-section {
    width: 130px;
  }
}

@media screen and (max-width: 699px) {
  .health-dashboard {
    flex-direction: column;
    padding: 12px;
  }
  .medicine-content {
    flex-direction: column;
  }
  .medicine-ring-section {
    width: 100%;
  }
  .medicine-heatmap {
    grid-template-columns: repeat(7, 1fr);
  }
  .score-content {
    flex-direction: column;
    align-items: center;
  }
  .dimension-section {
    width: 100%;
  }
  .dimension-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .today-medicine-actions {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
  .digital-human-section {
    width: 100%;
    height: auto;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    gap: 20px;
  }
  .digital-human-container {
    margin-top: 0;
  }
  .points-badge {
    position: relative;
    left: auto;
    top: auto;
    transform: none;
  }
  .chat-bubble {
    margin-top: 0;
    max-width: 150px;
  }
}

.constitution-dialog :deep(.el-dialog__body) {
  max-height: 60vh;
  overflow-y: auto;
  padding: 20px;
}

.constitution-content {
  line-height: 1.8;
  color: #333;
  font-size: 14px;
}

.constitution-content :deep(img) {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
  margin: 10px 0;
}

.points-dialog :deep(.el-dialog__body) {
  padding: 20px 20px 10px 20px;
}

.points-table-container {
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #ebeef5;
}

.points-plus {
  color: #67c23a;
  font-weight: 600;
}

.points-minus {
  color: #f56c6c;
  font-weight: 600;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
}
</style>
